/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section3_P1Inputs */

const en_terms_section3_p1 = /** @type {(inputs: Terms_Section3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You agree to use PureJSON only for lawful purposes. You may not:`)
};

const ko_terms_section3_p1 = /** @type {(inputs: Terms_Section3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON은 합법적인 목적으로만 사용해야 합니다. 다음은 금지됩니다:`)
};

const ja_terms_section3_p1 = /** @type {(inputs: Terms_Section3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONは合法的な目的にのみ使用してください。以下の行為は禁止されています：`)
};

/**
* | output |
* | --- |
* | "You agree to use PureJSON only for lawful purposes. You may not:" |
*
* @param {Terms_Section3_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_section3_p1 = /** @type {((inputs?: Terms_Section3_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section3_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_section3_p1(inputs)
	if (locale === "ko") return ko_terms_section3_p1(inputs)
	return ja_terms_section3_p1(inputs)
});